export const AUSENTE = '—'
const DATA_ISO = /^(\d{4})-(\d{2})-(\d{2})$/

const moeda = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
})

// Não usa NUMBER_TO_CURRENCY (utils/helpers/Currency): ele devolve '' para 0,
// e uma conta de valor zero deve aparecer como R$ 0,00, não sumir.
export function formatarMoeda(valor: number | undefined): string {
  return valor === undefined ? AUSENTE : moeda.format(valor)
}

// `data_vencimento` chega como YYYY-MM-DD. Formatada por divisão da string:
// `new Date('2026-01-01')` é meia-noite UTC e, em fusos negativos, viraria 31/12.
export function formatarDataVencimento(data: string | undefined): string {
  if (!data) return AUSENTE

  const match = DATA_ISO.exec(data)
  if (!match) return data

  const [, ano, mes, dia] = match
  return `${dia}/${mes}/${ano}`
}

// Códigos da Conta Azul (EM_ABERTO, ATRASADO…) viram texto legível. Não há
// lista fechada de status: um código novo aparece humanizado, sem quebrar.
export function formatarStatus(status: string | undefined): string {
  if (!status) return AUSENTE

  const texto = status.replace(/_/g, ' ').toLowerCase()
  return texto.charAt(0).toUpperCase() + texto.slice(1)
}
